import React, { useState } from "react";
import {
  TextField,
  Button,
  Snackbar,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useFirebase } from "../../../context/Firebase";
import { doc, setDoc } from "firebase/firestore";
import "./AddUser.css";
// import { createUserModel } from '../model/userModel' // Removed

const AddUser = () => {
  const { db, signupUserWithEmailAndPassword } = useFirebase();
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    name: "",
    email: "",
    bio: "",
    gender: "",
    phone: "",
    dob: "",
    blocked: false,
    isChatting: false,
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!userData.name.trim()) {
      setError("Name is required");
      return false;
    }
    if (!userData.email.includes("@")) {
      setError("Invalid email address");
      return false;
    }
    if (!userData.gender) {
      setError("Gender is required");
      return false;
    }
    if (userData.phone && !/^\d{10}$/.test(userData.phone)) {
      setError("Phone number must be 10 digits");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      // Upload profile picture or assign default
      let pictureUrl = "";

      // Always use default avatars to avoid storage quota issues
      if (userData.gender === "Female") {
        pictureUrl = "https://www.w3schools.com/howto/img_avatar2.png";
      } else if (userData.gender === "Male") {
        pictureUrl = "https://www.w3schools.com/howto/img_avatar.png";
      } else {
        pictureUrl = "https://www.w3schools.com/howto/img_avatar.png";
      }

      // Firebase user auth
      const userCredential = await signupUserWithEmailAndPassword(
        userData.email,
        "DefaultPassword123"
      );
      const user = userCredential.user;

      // Create new user object directly
      const newUser = {
        id: user.uid,
        name: userData.name,
        email: userData.email,
        bio: userData.bio,
        gender: userData.gender,
        phone: userData.phone,
        dob: userData.dob,
        picture: pictureUrl,
        blocked: userData.blocked, // Ensure these are included
        isChatting: userData.isChatting, // Ensure these are included
      };

      // Save user in Firestore
      await setDoc(doc(db, "users", user.uid), newUser);

      setSuccess(true);
      setTimeout(() => navigate("/admin"), 1500);
    } catch (err) {
      setError("Failed to add user: " + err.message);
    }
  };

  return (
    <div className="add-user">
      <h2>Add New User</h2>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          fullWidth
          name="name"
          value={userData.name}
          onChange={handleInputChange}
          required
          margin="normal"
        />
        <TextField
          label="Email"
          fullWidth
          name="email"
          value={userData.email}
          onChange={handleInputChange}
          required
          margin="normal"
        />
        <TextField
          label="Bio"
          fullWidth
          name="bio"
          value={userData.bio}
          onChange={handleInputChange}
          margin="normal"
        />
        <FormControl fullWidth margin="normal" required error={!userData.gender && error === "Gender is required"}>
          <InputLabel>Gender *</InputLabel>
          <Select
            name="gender"
            value={userData.gender}
            onChange={handleInputChange}
            required
          >
            <MenuItem value="">
              <em>Select Gender</em>
            </MenuItem>
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
            <MenuItem value="Non-binary">Non-binary</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
            <MenuItem value="Prefer not to say">Prefer not to say</MenuItem>
          </Select>
          {!userData.gender && error === "Gender is required" && (
            <p style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px', marginLeft: '14px' }}>
              Please select a gender option
            </p>
          )}
        </FormControl>
        <TextField
          label="Phone"
          fullWidth
          name="phone"
          value={userData.phone}
          onChange={handleInputChange}
          margin="normal"
        />
        <TextField
          label="Date of Birth"
          type="date"
          fullWidth
          name="dob"
          value={userData.dob}
          onChange={handleInputChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
        />

        <Button variant="contained" color="primary" type="submit" fullWidth>
          Add User
        </Button>
      </form>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        message={error}
        onClose={() => setError("")}
      />
      <Snackbar
        open={success}
        autoHideDuration={6000}
        message="User added successfully!"
        onClose={() => setSuccess(false)}
      />
    </div>
  );
};

export default AddUser;
